import { Box, Chip, Container, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  BillsConsumptionsFormatted,
  BillsTableRow,
  FiltersBills,
  FiltersChipsBills,
  GetBillsRequestBody,
  ORDER_BY_TYPE,
  SelectedDataPeriodBills,
  SelectedRows,
  SuppliesBills,
  TotalEnvirormentState,
} from "../../core/models/bills/bills.model";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { FormattedOwnerData } from "../../core/models/ownerData/ownerData.model";
import {
  downloadBill,
  getBills,
} from "../../core/services/bills/bills.service";
import {
  formatBills,
  formatFiltersBills,
  getDatesFromTo,
  getBillRequestBody,
  initialFiltersBills,
  getEnvirormentStateLabel,
  initialTotalEnvirormentState,
  setLocalstorageBillsFilters,
  removeLocalstorageBillsFilters,
  refreshLocalstorageBillsFilters,
  getLoacalstorageBillsFilters,
  getEmissionDatesFromTo,
  getSupplyOrBillGeneralData,
} from "../../utils/components/bills/bills.util";
import BillsTable from "./BillsTable/BillsTable";
import "./Bills.scss";
import ButtonElement from "../UI/ButtonElement/ButtonElement";
import BillsFilters from "./BillsFilters/BillsFilters";
import BillsCard from "./BillsCard/BillsCard";
import BillsDownload from "./BillsDownload/BillsDownload";
import BillsPagination from "./BillsPagination/BillsPagination";
import { useParams, useSearchParams } from "react-router-dom";
import BillsHeader from "./BillsHeader/BillsHeader";
import {
  formatCupsDetail,
  initialSuppliesDetail,
} from "../../utils/components/suppliesDetail/suppliesDetail.util";
import { getSuppliesDetail as getSuppliesDetailFetch } from "../../core/services/suppliesDetail/suppliesDetail.service";
import {
  GetSuppliesDetailRequestBody,
  SuppliesDetailObject,
} from "../../core/models/suppliesDetail/suppliesDetail.model";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import EmptyStateComponent from "../UI/EmptyStateComponent/EmptyStateComponent";
import LoadingComponentComponent from "../UI/LoadingComponentComponent/LoadingComponentComponent";
import BillsEvolution from "./BillsEvolution/BillsEvolution";
import { SearchParams } from "../../core/models/consumptionsBillsSearchBar/consumptionsBillsSearchBar.model";
import { ConsumptionsPeriodInformation } from "../../core/models/consumptions/consumptions.model";
import { initialOwnerDataCup } from "../../utils/ownerData/ownerData.util";
import SnackbarComponent from "../UI/SnackbarComponent/SnackbarComponent";
import { SupplyOrBillGeneralData } from "../../core/models/supplies/supplies.model";
import {
  getBillSelectedFromLocalStorage,
  getSupplySelectedFromLocalStorage,
} from "../../core/services/localStorage/localStorage.service";
import { DeleteAllFiltersButton } from "../DrawerFilters/DrawerFilters";
import { isNil } from "lodash";

const Bills = () => {
  const { t } = useTranslation();
  const { idCups } = useParams();
  const { ownerData, userData, snackbarData, setSnackbarData } =
    useContext(TotalEnergiesContext);
  const isDesktopViewport = useMediaQuery("(min-width:1575px)");
  const selectedSupply = getSupplySelectedFromLocalStorage();
  const selectedBillRow = getBillSelectedFromLocalStorage();

  const [searchParms] = useSearchParams();

  const isBillsOrigin = useMemo(
    () => searchParms.get("origin") === "bills" && !selectedSupply,
    [searchParms, selectedSupply]
  );

  const supplyGeneralData = useMemo(
    () => {
      if (
        !searchParms.has("origin") ||
        (isNil(selectedBillRow) && isNil(selectedSupply))
      ) {
        return null;
      }

      return getSupplyOrBillGeneralData({
        selectedBillRow: isBillsOrigin ? selectedBillRow : null,
        selectedSupply: !isBillsOrigin ? selectedSupply : null,
        isSupplyOrigin: searchParms.get("origin") === "supplies",
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isBillsOrigin]
  );
  const savedFilters = getLoacalstorageBillsFilters();
  const [orderBy, setOrderBy] = useState<string>("");
  const [suppliesDetail, setSuppliesDetail] = useState<SuppliesDetailObject>(
    initialSuppliesDetail
  );
  const [billsTableRows, setBillsTableRows] = useState<BillsTableRow[]>([]);
  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);
  const [totalRegistersQuery, setTotalRegistersQuery] = useState<string>("");
  const [totalSuppliesBills, setTotalSuppliesBills] = useState<SuppliesBills>({
    supplies: "",
    bills: "",
  });
  const [selectedTab, setSelectedTab] = useState<string>("invoiceHistory");
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [selectedRows, setSelectedRows] = useState<SelectedRows[]>([]);
  const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false);
  const [filtersBills, setFiltersBills] = useState<FiltersBills>(
    savedFilters ? JSON.parse(savedFilters!) : initialFiltersBills
  );
  const [filtersChipsBills, setFiltersChipsBills] = useState<
    FiltersChipsBills[]
  >([]);
  const [isDownloadDrawerOpen, setIsDownloadDrawerOpen] =
    useState<boolean>(false);
  const [isSelectedDownloader, setIsSelectedDownloader] =
    useState<boolean>(false);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [isHeaderLoading, setIsHeaderLoading] = useState<boolean>(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useState<SearchParams>({
    dateFrom: null,
    dateTo: null,
    ownerDataCup: initialOwnerDataCup,
  });
  const [pendingRequest, setPendingRequest] = useState<number>(0);
  const [selectedDataPeriod, setSelectedDataPeriod] =
    useState<SelectedDataPeriodBills>({
      consumptionBill: null,
      positionX: null,
      elements: [],
    });
  const [consumptionsList, setConsumptionsList] = useState<
    BillsConsumptionsFormatted[]
  >([]);
  const [
    consumptionsBillsPeriodInformation,
    setConsumptionsBillsPeriodInformation,
  ] = useState<ConsumptionsPeriodInformation>({
    dateFrom: "",
    dateTo: "",
    averageExpense: "",
  });
  const [totalEnvirormentState, setTotalEnvirormentState] =
    useState<TotalEnvirormentState>(initialTotalEnvirormentState);
  const [sortDirection, setSortDirection] = useState<ORDER_BY_TYPE>("desc");

  const getSuppliesDetail = useCallback(
    (
      { isAdministrator, idClient, idAdministrator }: FormattedOwnerData,
      idCups: string,
      token: string,
      cupsContractId: string,
      abortSignal: AbortSignal
    ) => {
      const getSuppliesRequestBody: GetSuppliesDetailRequestBody = {
        userid: isAdministrator ? idAdministrator : idClient,
        isAdmin: isAdministrator.toString(),
        cupsContractId: cupsContractId,
        cupsId: idCups,
      };

      getSuppliesDetailFetch(getSuppliesRequestBody, token, abortSignal)
        .then((response) => {
          setSuppliesDetail(formatCupsDetail(response));
          setIsHeaderLoading(false);
        })
        .catch((error) => {
          setIsHeaderLoading(false);
        });
    },
    [setIsHeaderLoading]
  );

  const getBillsTableRows = useCallback(
    async (
      formattedOwnerData: FormattedOwnerData,
      token: string,
      filtersBills: FiltersBills,
      page: number,
      rowsPerPage: number,
      generalData: SupplyOrBillGeneralData | null,
      abortSignal: AbortSignal
    ) => {
      const dateFromTo = getDatesFromTo(filtersBills);
      const emissionDatesFromTo = getEmissionDatesFromTo(filtersBills);
      const billRequestBody: GetBillsRequestBody = {
        ...getBillRequestBody(
          formattedOwnerData,
          filtersBills,
          page,
          rowsPerPage,
          generalData,
          dateFromTo,
          emissionDatesFromTo
        ),
      };

      setPendingRequest((prevPendingRequest) => prevPendingRequest + 1);

      getBills(billRequestBody, token, abortSignal)
        .then(
          ({
            bills,
            totalRegistrosQuery,
            totalFacturasGas,
            totalFacturasLuz,
            totalFacturasPagadas,
            totalFacturasPendientes,
            totalFacturasNoPagadas,
          }) => {
            setBillsTableRows(formatBills(bills));
            setTotalRegistersQuery(totalRegistrosQuery);
            setTotalEnvirormentState({
              totalCountGas: totalFacturasGas,
              totalCountLight: totalFacturasLuz,
              totalCountPaid: totalFacturasPagadas,
              totalCountNoPaid: totalFacturasNoPagadas,
              totalCountPending: totalFacturasPendientes,
            });
          }
        )
        .catch(() => {})
        .finally(() => {
          setIsTableLoading(false);
          setPendingRequest((prevPendingRequest) => {
            const number = prevPendingRequest - 1;

            setIsTableLoading(!!number);
            return number;
          });
        });
    },
    []
  );

  const getFiltersChips = useCallback((filtersBills: FiltersBills) => {
    setFiltersChipsBills([]);

    const formattedFiltersBills = formatFiltersBills(filtersBills);

    for (const [key, values] of Object.entries(formattedFiltersBills)) {
      const flatValues = Array.isArray(values) ? values.flat() : values;

      if (
        Array.isArray(flatValues) &&
        flatValues.length > 0 &&
        flatValues.some((val) => val)
      ) {
        const label = ["environmentCode", "billStateCode"].includes(key)
          ? t(
              `Tablas.${getEnvirormentStateLabel(key, flatValues[0] as string)}`
            )
          : flatValues[0];

        setFiltersChipsBills((prevFiltersChips) => [
          ...prevFiltersChips,
          {
            filterBillsKey: key as keyof FiltersBills,
            totalValues: flatValues.length,
            label: typeof label === "string" ? label : String(label),
          },
        ]);
      }
    }
  }, []);

  useEffect(() => {
    if (isFirstLoad && totalRegistersQuery) {
      setTotalSuppliesBills((prevSuppliesBills) => ({
        ...prevSuppliesBills,
        bills: totalRegistersQuery,
      }));
      setIsFirstLoad(false);
    }
  }, [isFirstLoad, totalRegistersQuery]);

  useEffect(() => {
    const suppliesDetailsAbortController = new AbortController();
    const supply = getSupplySelectedFromLocalStorage();

    if (idCups && ownerData && userData) {
      setIsHeaderLoading(true);
      const contractId = supply?.contracts.at(-1)?.IdContrato.toString() || "";
      getSuppliesDetail(
        ownerData,
        idCups,
        userData.token,
        idCups ? contractId : "",
        suppliesDetailsAbortController.signal
      );

      return () => suppliesDetailsAbortController.abort();
    }
  }, [getSuppliesDetail, idCups, ownerData, userData]);

  useEffect(() => {
    const billsAbortController = new AbortController();

    if (ownerData && userData) {
      window.scrollTo({ top: 0, behavior: "auto" });
      setBillsTableRows([]);
      setIsTableLoading(true);
      getBillsTableRows(
        ownerData,
        userData.token,
        filtersBills,
        page,
        rowsPerPage,
        supplyGeneralData,
        billsAbortController.signal
      );
      setTotalSuppliesBills((prevSuppliesBills) => ({
        ...prevSuppliesBills,
        supplies: ownerData.supplyNumber,
      }));
      getFiltersChips(filtersBills);

      return () => {
        billsAbortController.abort();
      };
    }
  }, [
    supplyGeneralData,
    filtersBills,
    getBillsTableRows,
    getFiltersChips,
    ownerData,
    page,
    rowsPerPage,
    userData,
  ]);

  const handleClickDonwloadBill = async (id: string): Promise<void> => {
    if (userData) {
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      setIsDownloadLoading(true);
      await downloadBill(id, userData.token)
        .then(() => {
          if (!isMobile) {
            setSnackbarData({
              isOpen: true,
              isSuccessSeverity: true,
              text: "Descarga realizada con éxito",
            });
          }
          setIsDownloadLoading(false);
        })
        .catch((error) => {
          if (!isMobile) {
            setSnackbarData({
              isOpen: true,
              isSuccessSeverity: false,
              text: "Ha habido un error con la descarga",
            });
          }
          setIsDownloadLoading(false);
        });
    }
  };

  const handleDeleteChip = (filterBillsKey: string) => {
    setFiltersChipsBills((prevFiltersChips) =>
      prevFiltersChips.filter(
        ({ filterBillsKey: prevFilterBillsKey }) =>
          prevFilterBillsKey !== filterBillsKey
      )
    );

    const filtersBillsKey =
      filterBillsKey === "dateFromTo"
        ? ["dateFrom", "dateTo"]
        : filterBillsKey === "importMinMax"
        ? ["amountMin", "amountMax"]
        : filterBillsKey === "emissionDateFromTo"
        ? ["emissionDateFrom", "emissionDateTo"]
        : filterBillsKey;

    setFiltersBills((prevFiltersBills) => {
      let newFilters = prevFiltersBills;

      if (Array.isArray(filtersBillsKey)) {
        filtersBillsKey.forEach((billsKey) => {
          newFilters = {
            ...newFilters,
            [billsKey]: initialFiltersBills[billsKey as keyof FiltersBills],
          };
        });

        setLocalstorageBillsFilters(newFilters);
        return newFilters;
      }

      const newReturnFilters = {
        ...newFilters,
        [filtersBillsKey]:
          initialFiltersBills[filtersBillsKey as keyof FiltersBills],
      };
      setLocalstorageBillsFilters(newReturnFilters);

      return newReturnFilters;
    });
  };

  const handleDeleteAll = () => {
    setFiltersChipsBills([]);
    removeLocalstorageBillsFilters();
    setSelectedRows([]);
    setFiltersBills(initialFiltersBills);
    setPage(0);
  };

  const getIdCups = (codeCups: string) =>
    ownerData?.cups.find(({ codeCups: code }) => code === codeCups)?.idCups;
  const showNoResults =
    !isTableLoading && !!!billsTableRows.length && !pendingRequest;

  return (
    <Box
      component="section"
      className="bills"
      paddingBottom={{ xs: "1rem", md: "5rem" }}
    >
      <BillsHeader
        totalSuppliesBills={totalSuppliesBills}
        isDesktopViewport={isDesktopViewport}
        suppliesDetail={suppliesDetail}
        idCups={idCups}
        isHeaderLoading={isHeaderLoading}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {selectedTab === "invoiceHistory" && (
        <>
          <Container
            maxWidth="xl"
            component="article"
            className="bills__table-filters-container"
          >
            <Box
              component="div"
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={3}
            >
              <Box component="div" flexBasis="100%">
                <ButtonElement
                  onClick={() => setIsFiltersOpen(true)}
                  secondary
                  iconL
                  iconName="t-icon-filter"
                  disabled={
                    !!!billsTableRows.length && !!!filtersChipsBills.length
                  }
                >
                  {t("Tablas.Filtros")}{" "}
                  {!!filtersChipsBills.length && (
                    <span className="bills__filter-count">
                      {filtersChipsBills.length}
                    </span>
                  )}
                </ButtonElement>
                {!!filtersChipsBills.length &&
                  filtersChipsBills.map(
                    ({ filterBillsKey, label, totalValues }) => (
                      <Chip
                        className="filter-chip"
                        key={filterBillsKey}
                        label={
                          <Typography>
                            {label}{" "}
                            {totalValues > 1 && (
                              <span className="bills__filter-count">
                                +{totalValues - 1}
                              </span>
                            )}
                          </Typography>
                        }
                        onDelete={() => {
                          handleDeleteChip(filterBillsKey);
                          setPage(0);
                          refreshLocalstorageBillsFilters(filtersBills);
                        }}
                      />
                    )
                  )}
              </Box>
              <BillsFilters
                isFiltersOpen={isFiltersOpen}
                setIsFiltersOpen={setIsFiltersOpen}
                filtersBills={filtersBills}
                setFiltersBills={(filtersBills) => {
                  setFiltersBills(filtersBills);
                  setLocalstorageBillsFilters(filtersBills);
                  setPage(0);
                  setSelectedRows([]);
                }}
                ownerDataCups={ownerData?.cups || []}
                totalEnvirormentState={totalEnvirormentState}
              />
              <DeleteAllFiltersButton
                handleDeleteAll={handleDeleteAll}
                isTableLoading={isTableLoading}
                totalRegistersQuery={+totalRegistersQuery}
                totalFiltersApplied={filtersChipsBills.length}
                showNoResults={showNoResults}
              />
            </Box>
          </Container>
          {!showNoResults ? (
            <Container
              maxWidth="xl"
              component="article"
              sx={{ position: "relative" }}
            >
              {isDesktopViewport ? (
                <>
                  <BillsTable
                    billsTableRows={billsTableRows}
                    handleClickDonwloadBill={handleClickDonwloadBill}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    hasIdCups={!!idCups}
                    getIdCups={getIdCups}
                    isDownloadLoading={isDownloadLoading}
                    orderBy={orderBy}
                    setPage={setPage}
                    setOrderBy={setOrderBy}
                    sortDirection={sortDirection}
                    setSortDirection={setSortDirection}
                    setFiltersBills={setFiltersBills}
                  />
                  <BillsDownload
                    isDownloadDrawerOpen={isDownloadDrawerOpen}
                    isSelectedDownloader={isSelectedDownloader}
                    setIsDownloadDrawerOpen={setIsDownloadDrawerOpen}
                    setIsSelectedDownloader={setIsSelectedDownloader}
                    selectedSupply={selectedSupply}
                    selectedRows={selectedRows}
                    filtersBills={filtersBills}
                    isFilterApplied={savedFilters != null ? true : false}
                  />
                </>
              ) : (
                <BillsCard
                  billsTableRows={billsTableRows}
                  handleClickDonwloadBill={handleClickDonwloadBill}
                  hasIdCups={!!idCups}
                  getIdCups={getIdCups}
                  isDownloadLoading={isDownloadLoading}
                />
              )}
              {isTableLoading && (
                <Box padding={"2rem 0"}>
                  <LoadingComponentComponent
                    isLoading={isTableLoading}
                    backgroundColor={"transparent"}
                    position={"relative"}
                    height={"4rem"}
                  />
                </Box>
              )}
              {!!billsTableRows.length && (
                <BillsPagination
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  selectedRows={selectedRows}
                  setIsDownloadDrawerOpen={setIsDownloadDrawerOpen}
                  setIsSelectedDownloader={setIsSelectedDownloader}
                  totalRegistersQuery={+totalRegistersQuery}
                  isDesktopViewport={isDesktopViewport}
                  isTableLoading={isTableLoading}
                />
              )}
            </Container>
          ) : (
            <Container maxWidth="xl" component="article">
              <EmptyStateComponent text={"No hay resultados"} height="17rem" />
            </Container>
          )}
        </>
      )}
      {selectedTab === "evolution" && (
        <BillsEvolution
          currentCups={selectedSupply}
          ownerDataCups={ownerData?.cups || []}
          userData={userData}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          selectedDataPeriod={selectedDataPeriod}
          setSelectedDataPeriod={setSelectedDataPeriod}
          consumptionsList={consumptionsList}
          setConsumptionsList={setConsumptionsList}
          consumptionsBillsPeriodInformation={
            consumptionsBillsPeriodInformation
          }
          setConsumptionsBillsPeriodInformation={
            setConsumptionsBillsPeriodInformation
          }
        />
      )}
      <SnackbarComponent
        snackbarData={snackbarData}
        setSnackbarData={setSnackbarData}
      />
    </Box>
  );
};

export default Bills;
